"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isDraftId(id) {
    return id.startsWith('drafts.');
}
exports.isDraftId = isDraftId;
exports.prefixId = (id) => (id.startsWith('drafts.') ? id : `drafts.${id}`);
exports.unprefixId = (id) => id.replace(/^drafts\./, '');
exports.safeId = (id, makeSafe) => {
    return /^(image|file)-[a-z0-9]{32,}-/.test(id) ? id : makeSafe(id);
};
//# sourceMappingURL=documentIds.js.map